export class Omnidia {
    Effectif: number;
    NombreTaxon: number;
    NombreGenre: number;
    Equitabilite: number;
    Shannon: number;
    NoteIPS: number;
    RemarqueDetermination: string;

    static mapFromJSON(json): any {
        const o = new Omnidia();

        o.Effectif = json.effectif;
        o.NombreGenre = json.nombreGenre;
        o.NombreTaxon = json.nombreTaxon;
        o.NoteIPS = json.noteIPS;
        o.Equitabilite = json.equitabilite;
        o.Shannon = json.shannon;
        o.RemarqueDetermination = json.remarqueDetermination;

        return o;
    }
}